import React from 'react';
import { MuiGrid, MuiTypography, MuiFormControl, MuiToolTip, MuiFormControlLabel, MuiRadioGroup, MuiKeyboardArrowUp, MuiKeyboardArrowDown, MuiButton } from '../../../ui/MaterialUIComponents';
import { withStyles } from '@material-ui/core/styles';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import theme from '../../../../assests/theme';
import { RulesMenuComponent } from '.';
import { isErrorMethod } from './HandleErrorUtil'
import { GradePickerComponent, gradePickerUtil } from '../../gradePicker';
import * as Constants from '../../../../constants';
import lodashUtil from 'lodash';
import PageHeaderComponent from '../../../ui/PageHeaderComponent'
import { Radio, Switch, CheckBox } from '../../../ui/customUIComponents'
import { showToasterForRulesDisplay, getTableCellShowMode, getTableCellShowModeForElective } from './RulesDisplayUtil';
import AlertDialogComponent from '../teacher/AlertDialogComponent';
import { saveSchoolConcurrently, saveSchoolScheduleConstraintsConcurrently } from '../../../../utils/ConcurrentSchoolSaveUtil';

import spinner from "../../../ui/icons/spinner.gif";
import { ScheduleConstants } from '../schedule/ScheduleConstants';
const styles = () => ({

	table: {
		minWidth: 1150,
	},
	table_Container: {

	},
	customWidth: {
		maxWidth: 150
	},
	tableCell_1: {
		minWidth: 150,
	},
	tableCell_n: {
		minWidth: 70,
	},
	tableCell_totalPrd_n: {
		minWidth: 70,
		border: '1px solid ' + theme.palette.orange
	},
	filter_row: {
		width: '100%'
	},
	filter_row_style: {
		minWidth: 600,
	},
	header_row: {
		minWidth: 1150,
	},

	// show_bar: {
	// 	minWidth: 570,
	// },
	errorCell_n: {
		minWidth: 70,
		outline: "2px solid red"
	}
});


class RulesComponent extends React.Component {

	constructor(props) {
		super(props);
		this.showGroupsFilter = React.createRef();
		this.state = {
			keys: [],
			totalPeriodsCreated: false, //This boolean is to track if any total period is created which needs to be saved
			cellCode: null,
			displayError: false,
			errorLog: props.activeSchool.schedule_constraints[props.activeScheduleIndex].errorLog,
			shouldRender: false,
			showRadioButtonValue: Constants.RULES_SHOW_RADIO_PERIOD,
			showRules: false,
			appliedChanges: false,
			schedule_constraints_backup: JSON.parse(JSON.stringify(this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex])),
			alertDialogComponent: false,
			ctrlKeyPressed: false,
		}
	}
	onClickOfShowRulesCheckBox = (event) => {
		const i18n = this.props.i18n
		if (event.target.checked) {
			showToasterForRulesDisplay(this.state.showRadioButtonValue, i18n);
		}
		this.checkIfShowSectionsRequired();
		let keys = this.state.keys;
		for (let index = 0; index < keys.length; index++) {
			if (this.props.dataTableMap.get(keys[index])) {
				this.props.dataTableMap.get(keys[index]).isSelected = false;
				this.props.dataTableMap.get(keys[index]).border = "";
			}

		}
		keys = [];
		this.setState({
			keys: keys,
			showRules: event.target.checked
		})


		//this.setState({ showRules:event.target.checked})

	}

	checkTotalPeriodSave = (refreshState) => {
		if (this.state.totalPeriodsCreated === true) {

		}
	}

	// to do 
	applyChangesMethod = async () => {
		if (this.state.totalPeriodsCreated === true) {
			this.setState({ totalPeriodsCreated: false })
			this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].modifiedDate = new Date()
			this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].enableGenerateTimeTable = false;
			this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].status = ScheduleConstants.INPROGRESS
			// let result = await saveSchoolConcurrently(this.props.editSchoolInformation,
			// 	this.props.userInformation._id,
			// 	this.props.activeSchool._id,
			// 	this.props.activeSchool,
			// 	this.props.i18n.commonTexts.saveSuccessful);
			
			let result = await saveSchoolScheduleConstraintsConcurrently(this.props.updateSchoolScheduleConstraints,
				this.props.userInformation._id,
				this.props.activeSchool._id,
				this.props.activeSchool,
				this.props.activeScheduleIndex,

				this.props.i18n.commonTexts.saveSuccessful);
			this.setState({
				appliedChanges: true,
				schedule_constraints_backup: JSON.parse(JSON.stringify(this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex]))
			});
		}
	}

	updateDialogSave = (schedule_constraints) => {
		this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex] = schedule_constraints
		this.setState({ totalPeriodsCreated: true });
	}

	// Setup the `beforeunload` event listener
	setupBeforeUnloadListener = () => {
		window.addEventListener("beforeunload", (ev) => {
			ev.preventDefault();
			return this.checkTotalPeriodSave(false);
		});
	};

	shouldEnablePreCheck = () => {
		let flag = true
		let masterModifiedDate = new Date(this.props.activeSchool.school_master.modifiedDate)
		let scheduleModifiedDate = new Date(this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].modifiedDate)
		if (this.state.totalPeriodsCreated == false) {
			if (!this.props.updateSchoolinformationInProgress && !this.props.disableEdit) {
				if (!this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].enableGenerateTimeTable) {
					if (this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].lastPreCheckedDate != undefined) {
						let lastPreCheckedDate = new Date(this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].lastPreCheckedDate)
						if (lastPreCheckedDate.getTime() < masterModifiedDate.getTime() || lastPreCheckedDate.getTime() < scheduleModifiedDate.getTime()) {
							flag = false
						}
					} else {
						flag = false
					}
				}
			}
		}

		return flag
	}

	showToolTipForErrors = () => {
		const i18n = this.props.i18n
		let data = i18n.log.errors + ' :' + ((this.props.errorLog.errorsCount != undefined) ? this.props.errorLog.errorsCount : 0) + ' , '
		data = data + (i18n.log.warnings + ' :' + ((this.props.errorLog.warningsCount != undefined) ? this.props.errorLog.warningsCount : 0))
		return data
	}
	handleClick = (event, key) => {
		
		let toggele = true
		let keys = this.state.keys;
		let jointClass = this.props.dataTableMap.get(key).jointClass
		if (event.ctrlKey || event.metaKey) {
			let keyIndex = keys.findIndex((arrayItem) => {
				return arrayItem == key;
			})
			//CTRL and DE-SELECTING
			if (keyIndex != -1) {
				if (jointClass != undefined) {
					this.deselectingRespectiveJointClassCell(this.props.dataTableMap, jointClass, keys)
				} else {
					this.props.dataTableMap.get(keys[keyIndex]).isSelected = false;
					this.props.dataTableMap.get(keys[keyIndex]).border = "";
					//keys.splice(keyIndex, 1)
				}
				keys.splice(keyIndex, 1)
			}
			//CTRL and SELECTING
			else {
				keys.push(key)
				if (jointClass !== undefined) {
					this.selectingRespectiveJointClassCell(this.props.dataTableMap, jointClass, keys)
				} else {
					this.props.dataTableMap.get(key).isSelected = true;
					this.props.dataTableMap.get(key).border = "2px solid green";
				}
			}

		}
		// single cell selected and removing the border for other cells in the keys array
		else {
			for (let index = 0; index < keys.length; index++) {
				if (this.props.dataTableMap.get(keys[index])) {
					this.props.dataTableMap.get(keys[index]).isSelected = false;
					this.props.dataTableMap.get(keys[index]).border = "";
				}
			}
			keys = [];
			keys.push(key)
			// after removing the border for other cells in keys array.
			// ADDING BORDER to the selected cell.
			if (jointClass !== undefined) {
				this.selectingRespectiveJointClassCell(this.props.dataTableMap, jointClass, keys)
			} else {
				this.props.dataTableMap.get(key).isSelected = true;
				this.props.dataTableMap.get(key).border = "2px solid green";
			}
		}
		this.checkTotalPeriodSave(true);
		this.setState({
			toggele: !toggele,
			keys: keys,
			cellCode: key,
		})
	}

	selectingRespectiveJointClassCell = (dataTableMap, jointClassObj, keys) => {
		for (let [key, value] of dataTableMap) {
			if (value.jointClass != undefined) {
				if (value.jointClass._id == jointClassObj._id) {
					value.isSelected = true;
					value.border = "2px solid green";
					if (!keys.includes(key)) {
						keys.push(key);
					}
				}
			}
		}
	}

	deselectingRespectiveJointClassCell = (dataTableMap, jointClassObj, keys) => {
		for (let [key, value] of dataTableMap) {
			if (value.jointClass !== undefined) {
				if (value.jointClass._id == jointClassObj._id) {
					value.isSelected = false;
					value.border = "";
					//we commenting this for verifying , after verifying functionality is working fine
					// if (!keys.includes(key)) {
					// 	keys.push(key);
					// }
				}
			}
		}
	}
	//TODO 
	doesGroupHasTotalPeriod(cellData) {
		if (cellData.subject) {
			let totalPeriods = this.props.schedule.totalPeriods;
			if (totalPeriods) {
				let subjectCells = totalPeriods.filter(item => item.subjectCode === cellData.subject.code);
				if (subjectCells) {

				}
			}
		}
	}
	selectElementContents(el) {
		var range = document.createRange();
		range.selectNodeContents(el);
		var sel = window.getSelection();
		sel.removeAllRanges();
		sel.addRange(range);
	}
	resetCellFocus(sibling, key, nextKey) {

		let toggele = true
		if (sibling != null && (sibling.bgColor === "")) {
			sibling.firstElementChild.firstElementChild.focus();
			var event = new MouseEvent('mouseover', {
				view: window,
				bubbles: true,
				cancelable: true
			});

			sibling.firstElementChild.firstElementChild.dispatchEvent(event);
			this.selectElementContents(sibling.firstElementChild.firstElementChild);
			let dataCellData = this.props.dataTableMap.get(key);
			dataCellData.isSelected = false;

			let keys = [];
			keys.push(nextKey)
			this.props.dataTableMap.get(nextKey).isSelected = true;
			this.setState({
				toggele: !toggele,
				keys: keys,
				cellCode: key,
			})

		}
	}
	handleNavigation = (event, rowIndex, columnIndex, normalizedKeyCode) => {
		let currentTd = event.target.parentElement.parentElement;
		if (currentTd && currentTd.tagName != "TD") {
			return;
		}
		let nextColumnIndex = columnIndex;
		let nextRowIndex = rowIndex;
		let idx = currentTd.cellIndex;
		let key = rowIndex + "-" + columnIndex;
		if (normalizedKeyCode === Constants.KEY_LEFT) {//37
			let sibling = currentTd.previousElementSibling;
			nextColumnIndex = nextColumnIndex - 1;
			let nextKey = nextRowIndex + "-" + nextColumnIndex;

			this.resetCellFocus(sibling, key, nextKey);
			;
		} else if (normalizedKeyCode === Constants.KEY_UP) {//38

			let nextrow = currentTd.parentElement.previousElementSibling;
			nextRowIndex = nextRowIndex - 1;
			let nextKey = nextRowIndex + "-" + nextColumnIndex;
			if (nextrow != null) {
				let sibling = nextrow.cells[idx];
				this.resetCellFocus(sibling, key, nextKey);

			}

		} else if (normalizedKeyCode === Constants.KEY_DOWN) {//40

			let nextrow = currentTd.parentElement.nextElementSibling;
			nextRowIndex = nextRowIndex + 1;
			let nextKey = nextRowIndex + "-" + nextColumnIndex;
			if (nextrow != null) {
				let sibling = nextrow.cells[idx];
				this.resetCellFocus(sibling, key, nextKey);
			}

		} else if (normalizedKeyCode === Constants.KEY_RIGHT) {//39
			let sibling = currentTd.nextElementSibling;
			nextColumnIndex = nextColumnIndex + 1;
			let nextKey = nextRowIndex + "-" + nextColumnIndex;
			this.resetCellFocus(sibling, key, nextKey);
		}
	}

	totalPeriodValidation = (cellData, totalPeriodValue) => {
		let multiPeriod = cellData.multiPeriod
		let preferencesArray = multiPeriod.preferences
		let multiPeriodTotal = 0;
		let alertDialogComponent = false;
		for (let i = 0; i < preferencesArray.length; i++) {
			let preferenceObj = preferencesArray[i]
			multiPeriodTotal += (Number(preferenceObj.noOfStandardPeriods) * Number(preferenceObj.numberOfInstances))
		}
		if (totalPeriodValue < multiPeriodTotal) {
			alertDialogComponent = true;
		}
		this.setState({
			alertDialogComponent: alertDialogComponent
		})
		return alertDialogComponent
	}

	totalPeriodsSaving = (event, cellValue) => {
		let keys = this.state.keys
		for (let a = 0; a < keys.length; a++) {
			let key = keys[a]
			let cellData = this.props.dataTableMap.get(key)
			let totalPeriod = this.constructTotalPeriodsObject(cellData, cellValue)
			if (cellData.multiPeriod != undefined) {
				this.setState({
					cellData: cellData,
					cellValue: cellValue,
					target: event.target
				})
				let totalPeriodLessThanMultiPeriod = this.totalPeriodValidation(cellData, cellValue)
				if (totalPeriodLessThanMultiPeriod === false) {
					this.savingOfTotalPeriods(cellData, totalPeriod)
					this.setState({ totalPeriodsCreated: true, appliedChanges: false });
				}
			} else {
				this.savingOfTotalPeriods(cellData, totalPeriod)
				this.setState({ totalPeriodsCreated: true, appliedChanges: false });
			}
		}
	}

	handleOnBlur = (event, rowIndex, columnIndex) => {
		if (this.state.showRules === true || this.state.ctrlKeyPressed === true) {
			event.preventDefault();
			return;
		}

		let cellKey = rowIndex + "-" + columnIndex;
		let cellValue = event.target.textContent;
		let keys = this.state.keys
		if (cellValue != undefined && (/[\d]+/g.test(cellValue) || cellValue.length === 0)) {
			cellValue = Number(cellValue);

			if (cellValue >= 0) {
				let cellDataObj = this.props.dataTableMap.get(cellKey)
				if (cellDataObj.totalPeriod != undefined) {
					if (cellDataObj.totalPeriod.count != cellValue) {
						this.totalPeriodsSaving(event, cellValue)
					}
				} else if (cellDataObj[Constants.RULES_TOTAL_PERIOD_DATATABLE_SHOW_KEY] != undefined) {
					//check if cellData has show information for Grade since it is present
					if (cellValue > 0) {
						this.totalPeriodsSaving(event, cellValue)
					} else {
						event.target.textContent = cellDataObj[Constants.RULES_TOTAL_PERIOD_DATATABLE_SHOW_KEY]
					}
				}
				// total period obj is not present
				else {
					if (cellValue > 0) {
						this.totalPeriodsSaving(event, cellValue)
					}
					//if the cell dosent have total periods and 0 is entered set it back to "" so it dosent show anything (blank)
					else {
						event.target.textContent = ""
					}
				}
			}
		}
		this.setState({
			ctrlKeyPressed: false,
		})
	}

	constructTotalPeriodsObject = (cellData, cellValue) => {
		let totalPeriod = {
			count: cellValue
		}
		let jointClassId = undefined
		if (cellData.jointClass != undefined) {
			jointClassId = cellData.jointClass._id
		}

		if (cellData.subject != undefined) {
			totalPeriod.jointClassId = jointClassId
			totalPeriod.subjectId = cellData.subject._id
			totalPeriod.subjectName = cellData.subject.name
			totalPeriod.subjectCode = cellData.subject.code
		}
		// selected cell is for elective
		else {
			totalPeriod.jointClassId = jointClassId
			totalPeriod.electiveId = cellData.elective._id
			totalPeriod.electiveName = cellData.elective.name
		}
		return JSON.parse(JSON.stringify(totalPeriod))
	}

	setTotalPeriodsInCell = (cellData, totalPeriod) => {
		let tempActiveSchool = this.props.activeSchool;
		let cellDetails = cellData;
		let gradeLevels = this.props.activeSchool.school_master.gradeLevels
		let objMatching = false;
		let templetObjForCreatingNewObj = undefined;
		let totalPeriods = tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].totalPeriods
		totalPeriod.showTotalPeriodString = totalPeriod.count.toString();
		if (lodashUtil.isEmpty(this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex])) {
			tempActiveSchool.schedule_constraints = [
				{ totalPeriods: [] }
			]
		}

		let cellGradeDetails = undefined;
		if (cellDetails.subject !== undefined) {
			cellGradeDetails = cellDetails.subject.gradeDetails
		} else if (cellDetails.elective !== undefined) {
			cellGradeDetails = cellDetails.elective.gradeDetails
		}
		// "EDIT" if totalPeriods is already present 
		if (cellDetails.totalPeriod !== undefined) {
			//EDITING FOR GROUPS
			if (this.props.filter.showSections === true) {
				let count = 0;
				let index = undefined;
				let id = cellDetails.totalPeriod._id;
				let obj = lodashUtil.find(totalPeriods, ['_id', id]);
				// checking if the count is same first
				if (obj != undefined) {
					if (obj.count === totalPeriod.count) {
						objMatching = true;
					} else {
						objMatching = false;
					}
				}

				if (objMatching === false) {
					// remove obj code 
					for (let d = 0; d < totalPeriods.length; d++) {
						let gradeObj = totalPeriods[d].gradeDetails.grades[0]
						if ((cellDetails.subject && cellDetails.subject._id == totalPeriods[d].subjectId) || (cellDetails.elective && cellDetails.elective._id == totalPeriods[d].electiveId)) {
							if (gradeObj.grade === cellDetails.grade) {
								count++
								if (gradeObj.groups.length === 0) {
									index = d;
								}
							}
						}
					}
					// SPLICE
					let subGradeObj;
					let isLevelPresent = lodashUtil.find(cellGradeDetails.gradeLevels, ['level', cellDetails.gradeLevel])
					if (isLevelPresent !== undefined) {
						let gradeLevelObj = lodashUtil.find(gradeLevels, ['levelName', cellDetails.gradeLevel])
						if (gradeLevelObj !== undefined)
							subGradeObj = lodashUtil.find(gradeLevelObj.grades, ["gradeName", cellDetails.grade]);
					} else {
						subGradeObj = lodashUtil.find(cellGradeDetails.grades, ["grade", cellDetails.grade]);
					}
					// check if the SUBJECT is present for all the grade if not for all the GROUPS for the selected GRADE.
					if (cellGradeDetails.allGrades === true || subGradeObj.groups.length === 0) {
						for (let p = 0; p < gradeLevels.length; p++) {
							let gradeLevel = gradeLevels[p]
							let selectedObj = lodashUtil.find(gradeLevel.grades, ["gradeName", cellDetails.grade])
							if (selectedObj !== undefined) {
								if ((count === (selectedObj.groups.length + 1)) && index !== undefined) {
									totalPeriods.splice(index, 1);
									break;
								}
							}
						}
					}
					// SUBJECT is there only for SOME GROUPS in that grade.
					else {
						if ((count === (subGradeObj.groups.length + 1)) && index !== undefined) {
							totalPeriods.splice(index, 1);
						}
					}
				}
				let objIndex = lodashUtil.findIndex(totalPeriods, ['_id', id]);
				if (objIndex !== -1) {
					tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].totalPeriods[objIndex].count = totalPeriod.count
					tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].totalPeriods[objIndex].showTotalPeriodString = totalPeriod.showTotalPeriodString
				}
			}
			//"EDITING FOR GRADES" show sections is false so we are clicking on grades which already has the data 
			else {
				let id = cellDetails.totalPeriod._id;
				let objMatching = false;
				// let presentGroupArray = [];
				let obj = lodashUtil.find(totalPeriods, ['_id', id]);
				if (obj != undefined) {
					if (obj.count === totalPeriod.count) {
						objMatching = true;
					} else {
						objMatching = false;
					}
				}

				if (objMatching === false) {
					//all the groups should be over ridden with this value
					for (let h = 0; h < totalPeriods.length; h++) {

						if ((cellDetails.subject && cellDetails.subject._id == totalPeriods[h].subjectId) || (cellDetails.elective && cellDetails.elective._id == totalPeriods[h].electiveId)) {
							if (totalPeriods[h].gradeDetails.grades[0].grade === cellDetails.grade) {
								totalPeriods[h].count = totalPeriod.count;
								totalPeriods[h].showTotalPeriodString = totalPeriod.showTotalPeriodString;

								if (totalPeriods[h].gradeDetails.grades[0].groups.length != 0) {
									if (templetObjForCreatingNewObj === undefined) {
										templetObjForCreatingNewObj = JSON.parse(JSON.stringify(totalPeriods[h]))
									}
								}
							}
						}
					}
				}
				//creating NEW Object or REPLACING the obejct for groups
				this.creatingTotalPeriodObjForJointClass(templetObjForCreatingNewObj, cellDetails, tempActiveSchool)
			}
		}

		//"NEW OBJECT" if totalPeriod is not present in the schedule constraint
		else {
			// if the selected cell is for the grade and not for groups
			if (cellDetails.group === undefined) {
				//grade's object from master
				for (let g = 0; g < gradeLevels.length; g++) {
					let gradeObj = lodashUtil.find(gradeLevels[g].grades, ['gradeName', cellDetails.grade]);
					//GRADE (groups is empty)
					if (gradeObj !== undefined) {
						let totalPeriodObj = { ...totalPeriod }
						let gradeDetails = {
							allGrades: false,
							gradeLevels: [{
								level: cellDetails.gradeLevel
							}],
							grades: [{
								grade: cellDetails.grade,
								groups: [],
							}],
						}
						totalPeriodObj.gradeDetails = gradeDetails;
						//attaching data to the particular cell
						tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].totalPeriods.push(totalPeriodObj);

						let existingGroupArray = [];
						for (let x = 0; x < totalPeriods.length; x++) {
							if ((cellDetails.subject && cellDetails.subject._id == totalPeriods[x].subjectId) || (cellDetails.elective && cellDetails.elective._id == totalPeriods[x].electiveId)) {
								if (totalPeriods[x].gradeDetails.grades[0].grade === cellDetails.grade && totalPeriods[x].gradeDetails.grades[0].groups.length > 0) {
									existingGroupArray.push(totalPeriods[x].gradeDetails.grades[0].groups[0].groupCode)
									totalPeriods[x].count = totalPeriod.count;
									totalPeriods[x].showTotalPeriodString = totalPeriod.showTotalPeriodString;

									if (templetObjForCreatingNewObj === undefined) {
										templetObjForCreatingNewObj = JSON.parse(JSON.stringify(totalPeriods[x]))
									}
								}
							}
						}
						// to create NEW data to all the groups  
						//  VALIDATIONS if the subject or elective has gradeDetails ALL GRADE = TRUE or there is NO GROUPS for the grade
						let commonGradeObj;
						let gradeObj = undefined
						for (let t = 0; gradeLevels.length; t++) {
							let gradeLevel = gradeLevels[t];
							gradeObj = lodashUtil.find(gradeLevel.grades, ['gradeName', cellDetails.grade]);
							if (gradeObj !== undefined) {
								break;
							}
						}
						if (cellGradeDetails !== undefined) {
							commonGradeObj = gradeObj;
						}

						for (let m = 0; m < commonGradeObj.groups.length; m++) {
							// AFTER GRADE => GROUPS
							if (!existingGroupArray.includes(commonGradeObj.groups[m].groupName)) {
								let totalPeriodObj = { ...totalPeriod }
								let gradeDetails = {
									allGrades: false,
									gradeLevels: [{
										level: cellDetails.gradeLevel
									}],
									grades: [{
										grade: cellDetails.grade,
										groups: [{
											groupCode: commonGradeObj.groups[m].groupName !== undefined ? commonGradeObj.groups[m].groupName : commonGradeObj.groups[m].groupCode
										}],
									}],
								}
								totalPeriodObj.gradeDetails = gradeDetails;
								tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].totalPeriods.push(totalPeriodObj)

								if (templetObjForCreatingNewObj === undefined) {
									templetObjForCreatingNewObj = JSON.parse(JSON.stringify(totalPeriodObj))
								}
							}
						}
						break;
					}
				}
				this.creatingTotalPeriodObjForJointClass(templetObjForCreatingNewObj, cellDetails, tempActiveSchool)
			}
			// selected cell for GROUPS
			else {
				let totalPeriodObj = { ...totalPeriod }
				let gradeDetails = {
					allGrades: false,
					gradeLevels: [{
						level: cellDetails.gradeLevel
					}],
					grades: [{
						grade: cellDetails.grade,
						groups: [
							{ groupCode: cellDetails.group }
						],
					}],
				}
				totalPeriodObj.gradeDetails = gradeDetails;
				totalPeriods.push(totalPeriodObj)
			}
		}
	}

	creatingTotalPeriodObjForJointClass = (templetObjForCreatingNewObj, cellDetails, tempActiveSchool) => {
		let cellDetails_grade = cellDetails.grade
		let id = cellDetails.subject != undefined ? cellDetails.subject._id : cellDetails.elective._id
		let jointClassArray = tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].jointClasses
		let totalPeriodsArray = tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].totalPeriods

		//JOINT CLASS ARRAY
		for (let a = 0; a < jointClassArray.length; a++) {
			let jointClassObj = JSON.parse(JSON.stringify(jointClassArray[a]));
			let gradeDetails_gradesArray = jointClassObj.gradeDetails.grades

			let gradeIndex = lodashUtil.findIndex(gradeDetails_gradesArray, ['grade', cellDetails_grade])
			if (gradeIndex != -1) {

				//JOINT CLASS GRADE 
				for (let b = 0; b < gradeDetails_gradesArray.length; b++) {
					let gradeObj = gradeDetails_gradesArray[b]

					// JOINT CLASS GROUPS 
					for (let c = 0; c < gradeObj.groups.length; c++) {
						let groupObj = gradeObj.groups[c];
						let isGroupObjPresent = false;

						//TOTAL PERIODS FROM DATABASE
						for (let d = 0; d < totalPeriodsArray.length; d++) {
							let totalPeriodObj = totalPeriodsArray[d];
							let totalPeriodObj_grades = totalPeriodObj.gradeDetails.grades[0]
							// REPLACING THE VALUES IN THE DATABASE ARRAY
							if ((totalPeriodObj.subjectId === id) || (totalPeriodObj.electiveId === id))
								if (totalPeriodObj_grades.grade === gradeObj.grade
									&& totalPeriodObj_grades.groups != undefined
									&& totalPeriodObj_grades.groups.length > 0
									&& totalPeriodObj_grades.groups[0].groupCode === groupObj.groupCode) {

									totalPeriodObj.count = templetObjForCreatingNewObj.count
									totalPeriodObj.showTotalPeriodString = templetObjForCreatingNewObj.showTotalPeriodString
									totalPeriodObj.jointClassId = jointClassObj.jointClassId
									isGroupObjPresent = true
									break;
								}
						}

						// CREATE NEW OBJECT FOR PARTICULAR GROUPS
						if (isGroupObjPresent === false) {
							let tempObj = JSON.parse(JSON.stringify(templetObjForCreatingNewObj));
							delete tempObj._id;
							tempObj.gradeDetails.grades[0].grade = gradeObj.grade;
							tempObj.gradeDetails.grades[0].groups[0].groupCode = groupObj.groupCode;
							tempObj.jointClassId = jointClassObj.jointClassId
							totalPeriodsArray.push(tempObj);
						}
					}
				}
			}
		}
	}

	savingOfTotalPeriods = (cellData, totalPeriod) => {
		this.setTotalPeriodsInCell(cellData, totalPeriod)
		this.attachingDataToCell();
	}

	componentDidMount() {
		// Activate the event listener
		this.setupBeforeUnloadListener();
	}

	componentWillUnmount = () => {
		if (this.state.totalPeriodsCreated && !this.state.appliedChanges && !this.props.disableEdit) {
			this.beforeUnload()
		}
	}

	beforeUnload = async () => {
		var flag = window.confirm('Do you want to Save Rules Changes?');
		if (flag) {
			await this.applyChangesMethod();
		}
		else {
			await this.undoChanges()
		}
	}
	attachingDataToCell = () => {
		let totalPeriods = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].totalPeriods;
		let dataTableMap = this.props.dataTableMap;
		for (let i = 0; i < totalPeriods.length; i++) {
			let grades = totalPeriods[i].gradeDetails.grades[0];
			if (this.props.filter.showSections === false) {
				if (grades.groups.length === 0) {
					for (let [key, value] of dataTableMap) {
						if ((value.subject && value.subject._id == totalPeriods[i].subjectId) || (value.elective && value.elective._id == totalPeriods[i].electiveId)) {
							if (value.grade === grades.grade) {
								value.totalPeriod = totalPeriods[i];
								dataTableMap.set(key, value);
								break;
							}
						}
					}
				}
			} else {
				if (grades.groups.length !== 0) {
					for (let [key, value] of dataTableMap) {
						if ((value.subject && value.subject._id == totalPeriods[i].subjectId) || (value.elective && value.elective._id == totalPeriods[i].electiveId)) {
							if (value.grade === grades.grade) {
								if (value.group === grades.groups[0].groupCode) {
									value.totalPeriod = totalPeriods[i];
									dataTableMap.set(key, value);
									break;
								}
							}
						}
					}
				}
			}
		}
		this.setState({
			shouldRender: !this.state.shouldRender
		})
	}

	handleKeyUp = (event) => {
		if (event.which === Constants.KEY_CONTROL) {
			this.setState({
				ctrlKeyPressed: false
			})
		}
	}

	isNavigationKeyPressed(event, normalizedEventKey) {
		if (Constants.ARROW_KEYS.includes(normalizedEventKey)) {
			return normalizedEventKey;
		}
		else if (event.shiftKey && normalizedEventKey === Constants.KEY_TAB) {
			//Treat as left Arrow Key
			return Constants.KEY_LEFT;
		} else if (normalizedEventKey === Constants.KEY_TAB) {
			//Treat as Right Arrow Key
			return Constants.KEY_RIGHT;
		} else if (event.shiftKey && (normalizedEventKey === Constants.KEY_ENTER || normalizedEventKey === Constants.KEY_RETURN)) {
			//Treat as Up Arrow Key
			return Constants.KEY_UP;
		} else if (normalizedEventKey === Constants.KEY_ENTER || normalizedEventKey === Constants.KEY_RETURN) {
			//Treat as Down Arrow Key
			return Constants.KEY_DOWN;
		} else {
			return -1;
		}

	}
	handleKeyDown = (event, rowIndex, columnIndex) => {

		if (this.state.showRules === true) {
			event.preventDefault();
			return;
		}
		if (event.ctrlKey === true) {
			this.setState({
				ctrlKeyPressed: true
			})
		}
		let key = rowIndex + "-" + columnIndex;
		let normalizedEventKey = event.which || event.keyCode;
		normalizedEventKey = this.isNavigationKeyPressed(event, normalizedEventKey);
		//if (Constants.ARROW_KEYS.includes(normalizedEventKey)) {
		if (normalizedEventKey > 0) {
			event.preventDefault();
			this.handleNavigation(event, rowIndex, columnIndex, normalizedEventKey);

			let lkeys = this.state.keys || [];
			//lkeys.push(key);
			for (let index = 0; index < lkeys.length; index++) {
				this.props.dataTableMap.get(lkeys[index]).isSelected = false;
				this.props.dataTableMap.get(lkeys[index]).border = "";
				//lkeys.splice(index, 1)
			}
			this.setState({
				//keys: lkeys,
				cellCode: key,
			})
		}
		//Handle Enter or Return
		/* else if (Constants.KEY_ENTER === normalizedEventKey || Constants.KEY_RETURN === normalizedEventKey) {
			event.preventDefault();
			this.handleOnBlur(event, rowIndex, columnIndex);
			this.checkTotalPeriodSave(true);
		} */
		//handle non number keys
		/* else if (!Constants.RULES_CELL_ALLOWED_KEYS.includes(event.keyCode)) {
			event.preventDefault();
		} */
		else if (this.isNonNumeric(event)) {
			event.preventDefault();
		}

	}

	isNonNumeric = (event) => {
		if (event.key.length === 1 && /\D/.test(event.key)) {
			return true;
		}

		return false;
	}
	handleMenuClick = (event) => {

		event.stopPropagation();
		let AnchorEl = event.currentTarget;
		const open = Boolean(AnchorEl);
		const id = open ? 'simple-popover' : undefined;
		this.setState({
			AnchorEl: AnchorEl,
			open: open,
			id: id
		})
	}
	handleClose = () => {
		let AnchorEl = null;
		let open = Boolean(AnchorEl);
		let id = open ? 'simple-popover' : undefined;
		this.setState({
			AnchorEl: AnchorEl,
			open: open,
			id: id
		})
	};

	getTotalPeriodsTableCell = (classes) => {
		let arr = [];
		if (this.props.filter !== undefined) {
			let gradeLevels = gradePickerUtil.constructGradeLevelJSON({ gradeLevels: this.props.masterGradeLevels }, this.props.filter.gradeDetails);
			if (gradeLevels.isAllChecked) {
				for (let i = 0; i < gradeLevels.gradeLevels.length; i++) {
					for (let j = 0; j < gradeLevels.gradeLevels[i].grades.length; j++) {
						let totalPeriodObject = this.props.getTotalPeriodsByGradeFromRules(gradeLevels.gradeLevels[i].levelName, gradeLevels.gradeLevels[i].grades[j].gradeName, gradeLevels.gradeLevels[i].grades[j].groups.length)
						let cell = <TableCell className={classes.tableCell_totalPrd_n} align='center' bgcolor={Constants.CC_RULES_TOTALPRD_ROW_BG} colspan={this.props.filter.showSections && gradeLevels.gradeLevels[i].grades[j].groups.length}><MuiTypography style={{ color: totalPeriodObject.color }} variant="caption">
							{totalPeriodObject.sumOfPeriodsInRules}/{totalPeriodObject.sumOfPeriodsInCalender}
						</MuiTypography></TableCell>
						arr.push(cell)
					}
				}
			} else if (gradeLevels.indeterminate) {
				for (let gradeLevelIndex = 0; gradeLevelIndex < gradeLevels.gradeLevels.length; gradeLevelIndex++) {
					if (gradeLevels.gradeLevels[gradeLevelIndex].isGradeLevelSelected) {
						for (let gradeIndex = 0; gradeIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades.length; gradeIndex++) {
							let totalPeriodObject = this.props.getTotalPeriodsByGradeFromRules(gradeLevels.gradeLevels[gradeLevelIndex].levelName, gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].gradeName, gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups.length)
							let cell = <TableCell className={classes.tableCell_totalPrd_n} align='center' bgcolor={Constants.CC_RULES_TOTALPRD_ROW_BG} colspan={this.props.filter.showSections && gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups.length}><MuiTypography style={{ color: totalPeriodObject.color }} variant="caption">
								{totalPeriodObject.sumOfPeriodsInRules}/{totalPeriodObject.sumOfPeriodsInCalender}
							</MuiTypography></TableCell>
							arr.push(cell)
						}
					} else if (gradeLevels.gradeLevels[gradeLevelIndex].isGradeLevelIntermediate) {
						for (let gradeIndex = 0; gradeIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades.length; gradeIndex++) {
							if (gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].isGradeSelected) {
								let totalPeriodObject = this.props.getTotalPeriodsByGradeFromRules(gradeLevels.gradeLevels[gradeLevelIndex].levelName, gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].gradeName, gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups.length)
								let cell = <TableCell className={classes.tableCell_totalPrd_n} align='center' bgcolor={Constants.CC_RULES_TOTALPRD_ROW_BG} colspan={this.props.filter.showSections && gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups.length}><MuiTypography style={{ color: totalPeriodObject.color }} variant="caption">
									{totalPeriodObject.sumOfPeriodsInRules}/{totalPeriodObject.sumOfPeriodsInCalender}
								</MuiTypography></TableCell>
								arr.push(cell)
							}
						}
					}
				}
			}
			return arr
		}
	}
	getGroupTotalPeriodsTableCell = (classes) => {
		let arr = [];

		let bgColor = Constants.CC_RULES_COLUMNHEADERS_BG;
		let errorColor = theme.palette.error.light
		if (this.props.filter !== undefined) {
			let gradeLevels = gradePickerUtil.constructGradeLevelJSON({ gradeLevels: this.props.masterGradeLevels }, this.props.filter.gradeDetails);
			if (gradeLevels.isAllChecked) {
				for (let i = 0; i < gradeLevels.gradeLevels.length; i++) {
					for (let j = 0; j < gradeLevels.gradeLevels[i].grades.length; j++) {
						for (let k = 0; k < gradeLevels.gradeLevels[i].grades[j].groups.length; k++) {
							let totalPeriodObject = this.props.getTotalPeriodsByGroupFromRules(gradeLevels.gradeLevels[i].levelName, gradeLevels.gradeLevels[i].grades[j].gradeName, gradeLevels.gradeLevels[i].grades[j].groups[k].groupName)
							let cell = <TableCell className={classes.tableCell_totalPrd_n} align='center' bgcolor={Constants.CC_RULES_TOTALPRD_ROW_BG}><MuiTypography style={{ color: totalPeriodObject.color }} variant="caption">
								{totalPeriodObject.sumOfPeriodsInRules}/{totalPeriodObject.sumOfPeriodsInCalender}
							</MuiTypography></TableCell>
							arr.push(cell);
						}
					}
				}
			} else if (gradeLevels.indeterminate) {
				for (let gradeLevelIndex = 0; gradeLevelIndex < gradeLevels.gradeLevels.length; gradeLevelIndex++) {
					if (gradeLevels.gradeLevels[gradeLevelIndex].isGradeLevelSelected) {
						for (let gradeIndex = 0; gradeIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades.length; gradeIndex++) {
							for (let groupIndex = 0; groupIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups.length; groupIndex++) {
								let totalPeriodObject = this.props.getTotalPeriodsByGroupFromRules(gradeLevels.gradeLevels[gradeLevelIndex].levelName, gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].gradeName, gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups[groupIndex].groupName)
								let cell = <TableCell className={classes.tableCell_totalPrd_n} align='center' bgcolor={Constants.CC_RULES_TOTALPRD_ROW_BG}><MuiTypography style={{ color: totalPeriodObject.color }} variant="caption">
									{totalPeriodObject.sumOfPeriodsInRules}/{totalPeriodObject.sumOfPeriodsInCalender}
								</MuiTypography></TableCell>
								arr.push(cell);
							}
						}
					} else if (gradeLevels.gradeLevels[gradeLevelIndex].isGradeLevelIntermediate) {
						for (let gradeIndex = 0; gradeIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades.length; gradeIndex++) {
							if (gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].isGradeSelected) {
								for (let groupIndex = 0; groupIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups.length; groupIndex++) {
									let totalPeriodObject = this.props.getTotalPeriodsByGroupFromRules(gradeLevels.gradeLevels[gradeLevelIndex].levelName, gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].gradeName, gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups[groupIndex].groupName)
									let cell = <TableCell className={classes.tableCell_totalPrd_n} align='center' bgcolor={Constants.CC_RULES_TOTALPRD_ROW_BG}><MuiTypography style={{ color: totalPeriodObject.color }} variant="caption">
										{totalPeriodObject.sumOfPeriodsInRules}/{totalPeriodObject.sumOfPeriodsInCalender}
									</MuiTypography></TableCell>
									arr.push(cell);
								}
							} else {
								for (let groupIndex = 0; groupIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups.length; groupIndex++) {
									if (gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups[groupIndex].isGroupSelected) {
										let totalPeriodObject = this.props.getTotalPeriodsByGroupFromRules(gradeLevels.gradeLevels[gradeLevelIndex].levelName, gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].gradeName, gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups[groupIndex].groupName)
										let cell = <TableCell className={classes.tableCell_totalPrd_n} align='center' bgcolor={Constants.CC_RULES_TOTALPRD_ROW_BG}><MuiTypography style={{ color: totalPeriodObject.color }} variant="caption">
											{totalPeriodObject.sumOfPeriodsInRules}/{totalPeriodObject.sumOfPeriodsInCalender}
										</MuiTypography></TableCell>
										arr.push(cell);
									}
								}
							}
						}
					}

				}
			}
			return arr
		}
	}
	getGradeTableCell = () => {
		let arr = [];
		let bgColor = Constants.CC_RULES_COLUMNHEADERS_BG
		let errorColor = theme.palette.error.light
		let borderData = '2px solid ' + theme.palette.error.main
		if (this.props.filter !== undefined) {
			let gradeLevels = gradePickerUtil.constructGradeLevelJSON({ gradeLevels: this.props.masterGradeLevels }, this.props.filter.gradeDetails);
			if (gradeLevels.isAllChecked) {
				for (let i = 0; i < gradeLevels.gradeLevels.length; i++) {
					for (let j = 0; j < gradeLevels.gradeLevels[i].grades.length; j++) {
						let isError = false
						if (this.props.activeErrorItem != {} && !this.props.filter.showSections) {
							isError = isErrorMethod('grade',
								this.props.activeErrorItem, gradeLevels.gradeLevels[i].grades[j])
						}
						let color = isError ? errorColor : bgColor
						let cell = <TableCell align='center' style={{ border: isError && borderData }}
							bgcolor={color} colspan={this.props.filter.showSections && gradeLevels.gradeLevels[i].grades[j].groups.length}><MuiTypography variant="caption">{gradeLevels.gradeLevels[i].grades[j].gradeName}</MuiTypography></TableCell>
						arr.push(cell)
					}
				}
			} else if (gradeLevels.indeterminate) {
				for (let gradeLevelIndex = 0; gradeLevelIndex < gradeLevels.gradeLevels.length; gradeLevelIndex++) {
					if (gradeLevels.gradeLevels[gradeLevelIndex].isGradeLevelSelected) {
						for (let gradeIndex = 0; gradeIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades.length; gradeIndex++) {
							let isError = false
							if (this.props.activeErrorItem != {} && !this.props.filter.showSections) {
								isError = isErrorMethod('grade', this.props.activeErrorItem,
									gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex])
							}
							let color = isError ? errorColor : bgColor
							let cell = <TableCell align='center' style={{ border: isError && borderData }} bgcolor={color}
								colspan={this.props.filter.showSections && gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups.length}><MuiTypography variant="caption">{gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].gradeName}</MuiTypography></TableCell>
							arr.push(cell)
						}
					} else if (gradeLevels.gradeLevels[gradeLevelIndex].isGradeLevelIntermediate) {
						for (let gradeIndex = 0; gradeIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades.length; gradeIndex++) {
							if (gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].isGradeSelected) {
								let isError = false
								if (this.props.activeErrorItem != {} && !this.props.filter.showSections) {
									isError = isErrorMethod('grade', this.props.activeErrorItem,
										gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex])
								}
								let color = isError ? errorColor : bgColor
								let cell = <TableCell align='center' style={{ border: isError && borderData }}
									bgcolor={color} colspan={this.props.filter.showSections && gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups.length}><MuiTypography variant="caption">{gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].gradeName}</MuiTypography></TableCell>
								arr.push(cell)
							}
						}
					}
				}
			}
			return arr
		}
	}
	getGroupTableCell = (classes) => {
		let arr = [];

		let bgColor = Constants.CC_RULES_COLUMNHEADERS_BG;
		let errorColor = theme.palette.error.light
		if (this.props.filter !== undefined) {

			let gradeLevels = gradePickerUtil.constructGradeLevelJSON({ gradeLevels: this.props.masterGradeLevels }, this.props.filter.gradeDetails);
			if (gradeLevels.isAllChecked) {
				for (let i = 0; i < gradeLevels.gradeLevels.length; i++) {
					for (let j = 0; j < gradeLevels.gradeLevels[i].grades.length; j++) {
						for (let k = 0; k < gradeLevels.gradeLevels[i].grades[j].groups.length; k++) {
							let isError = false
							if (this.props.activeErrorItem != {} && this.props.filter.showSections) {
								let groupName = gradeLevels.gradeLevels[i].grades[j].gradeName + gradeLevels.gradeLevels[i].grades[j].groups[k].groupName
								isError = isErrorMethod('group', this.props.activeErrorItem, groupName)
							}
							let color = isError ? errorColor : bgColor
							let cell = <TableCell className={!isError ? classes.tableCell_n : classes.errorCell_n} bgcolor={color} align='center' colspan={1}><MuiTypography variant="caption">{gradeLevels.gradeLevels[i].grades[j].groups[k].groupName}</MuiTypography></TableCell>
							arr.push(cell);
						}
					}
				}
			} else if (gradeLevels.indeterminate) {
				for (let gradeLevelIndex = 0; gradeLevelIndex < gradeLevels.gradeLevels.length; gradeLevelIndex++) {
					if (gradeLevels.gradeLevels[gradeLevelIndex].isGradeLevelSelected) {
						for (let gradeIndex = 0; gradeIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades.length; gradeIndex++) {
							for (let groupIndex = 0; groupIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups.length; groupIndex++) {
								let isError = false
								if (this.props.activeErrorItem != {} && this.props.filter.showSections) {
									let groupName = gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].gradeName + gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups[groupIndex].groupName

									isError = isErrorMethod('group', this.props.activeErrorItem, groupName)
								}
								let color = isError ? errorColor : bgColor
								let cell = <TableCell className={!isError ? classes.tableCell_n : classes.errorCell_n} bgcolor={color} align='center' colspan={1}><MuiTypography variant="caption">{gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups[groupIndex].groupName}</MuiTypography></TableCell>
								arr.push(cell);
							}
						}
					} else if (gradeLevels.gradeLevels[gradeLevelIndex].isGradeLevelIntermediate) {
						for (let gradeIndex = 0; gradeIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades.length; gradeIndex++) {
							if (gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].isGradeSelected) {
								for (let groupIndex = 0; groupIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups.length; groupIndex++) {
									let isError = false
									if (this.props.activeErrorItem != {} && this.props.filter.showSections) {
										let groupName = gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].gradeName + gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups[groupIndex].groupName

										isError = isErrorMethod('group', this.props.activeErrorItem, groupName)
									}
									let color = isError ? errorColor : bgColor
									let cell = <TableCell className={!isError ? classes.tableCell_n : classes.errorCell_n} bgcolor={color} align='center' colspan={1}><MuiTypography variant="caption">{gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups[groupIndex].groupName}</MuiTypography></TableCell>
									arr.push(cell);
								}
							} else {
								for (let groupIndex = 0; groupIndex < gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups.length; groupIndex++) {
									if (gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups[groupIndex].isGroupSelected) {
										let isError = false
										if (this.props.activeErrorItem != {} && this.props.filter.showSections) {
											let groupName = gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].gradeName + gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups[groupIndex].groupName

											isError = isErrorMethod('group', this.props.activeErrorItem, groupName)
										}
										let color = isError ? errorColor : bgColor
										let cell = <TableCell className={!isError ? classes.tableCell_n : classes.errorCell_n} bgcolor={color} align='center' colspan={1}><MuiTypography variant="caption">{gradeLevels.gradeLevels[gradeLevelIndex].grades[gradeIndex].groups[groupIndex].groupName}</MuiTypography></TableCell>
										arr.push(cell);
									}
								}
							}
						}
					}

				}
			}
			return arr
		}
	}


	editCellData = (cellData) => {
		return cellData.totalPeriod != undefined ? cellData.totalPeriod.count : cellData[Constants.RULES_TOTAL_PERIOD_DATATABLE_SHOW_KEY] || '';
	}
	getCellToolTip(cellData) {
		let subjectText = cellData.subject ? cellData.subject.name : cellData.elective.name;
		let gradeText = this.props.filter.showSections === true ? cellData.grade + " " + cellData.group : cellData.grade;
		return subjectText + " : " + gradeText;
	}
	getTableCell = (data, i, j, bgColor, borderData) => {

		/* if (this.state.showRules == false) { */
		return <TableCell bgcolor={bgColor} colspan={1} data={data} style={{ border: borderData }} align='center'>
			<MuiGrid
				container
				direction="row"
				justify="space-between"
				alignItems="flex-start"
			>
				{/* <MuiGrid
						item xs
						onClick={(event) => this.handleClick(event, i + "-" + j)}
						onKeyDown={(event) => this.handleKeyDown(event, i, j)}
						onBlur={(event) => this.handleOnBlur(event, i, j)}
						contenteditable={this.props.disableEdit?"false":"true"}>
						<MuiTypography variant="caption">{this.editCellData(data)}</MuiTypography>


					</MuiGrid> */}
				{this.getTableCellData(data, i, j)}
				<span class="cellToolTip">{this.getCellToolTip(data)}</span>
				<MuiGrid item >
					{data.isSelected && <RulesMenuComponent
						{...this.props}
						{...this.state}
						updateDialogSave={this.updateDialogSave}
						applyChangesMethod={this.applyChangesMethod}
					/>}
				</MuiGrid>
			</MuiGrid>
		</TableCell>
		/* } else {
			return getTableCellShowMode(data, this.state.showRadioButtonValue,this.props,this.state);
		} */


	}
	getTableCellData(data, i, j) {

		if (this.state.showRules == false && !this.props.disableEdit) {
			return <MuiGrid item xs
				onClick={(event) => this.handleClick(event, i + "-" + j)}
				onKeyDown={(event) => this.handleKeyDown(event, i, j)}
				onKeyUp={(event) => this.handleKeyUp(event)}
				onBlur={(event) => this.handleOnBlur(event, i, j)}
				contenteditable="true">
				{this.editCellData(data)}
				{/* <MuiTypography variant="caption">{this.editCellData(data)}</MuiTypography> */}
			</MuiGrid>;
		} else {

			return <MuiGrid item xs
				onClick={(event) => this.handleClick(event, i + "-" + j)}>
				{getTableCellShowMode(data, this.state.showRadioButtonValue)}
			</MuiGrid>;


		}

	}

	getTableBody = (subjects, gradeLevels, dataTableMap) => {
		let rowArray = [];
		for (let i = 0; i < this.props.subjectsAndElectivesMapSize; i++) {
			let cellArray = [];
			let key = Array.from(this.props.subjectsAndElectivesMap.keys())[i];

			cellArray.push(
				<TableCell bgcolor={Constants.CC_RULES_ROWHEADERS_BG} colspan={1}>
					<MuiTypography variant="caption">
						{key}
					</MuiTypography>


				</TableCell>
			);
			let data = undefined
			let electiveData = undefined
			for (let j = 0; j < this.props.gradesMapSize; j++) {
				let isError = false
				data = dataTableMap.get(i + "-" + j);
				if (data && data.elective !== undefined) {
					electiveData = data;
					if (this.props.activeErrorItem !== undefined && this.props.activeErrorItem.messageItem !== undefined && this.props.activeErrorItem.messageItem.SUB_GRP !== undefined && this.props.activeErrorItem.messageItem.SUB_GRP.length === 3) {
						if (electiveData.elective !== undefined && electiveData.elective.name.toLowerCase() === this.props.activeErrorItem.messageItem.SUB_GRP[2].toLowerCase()) {
							isError = isErrorMethod('elective-name', this.props.activeErrorItem, electiveData, 2)
						}
					}
				} else {
					if (this.props.activeErrorItem != {}) {
						isError = isErrorMethod('subject', this.props.activeErrorItem, data, 2)
					}
				}
				let cell = undefined;
				if (data !== undefined) {
					let bgColor = isError ? theme.palette.error.light : data.bgColor;
					let borderData = isError ? '2px solid ' + theme.palette.error.main : data.border;
					cell = this.getTableCell(data, i, j, bgColor, borderData);
				} else {
					cell = <TableCell bgcolor={Constants.CC_RULES_GREYCELLS_BG} colspan={1} />
				}
				cellArray.push(cell);
			}
			let row = <TableRow>{cellArray}</TableRow>
			rowArray.push(row);
			if (electiveData && electiveData.elective && electiveData.elective.subjects.length > 0) {
				for (let b = 0; b < electiveData.elective.subjects.length; b++) {
					cellArray = [];
					let cell = <TableCell bgcolor={Constants.CC_RULES_ELECTIVE_BG} colspan={1}><MuiTypography variant="caption">--{electiveData.elective.subjects[b].name}</MuiTypography></TableCell>
					cellArray.push(cell);
					for (let a = 0; a < this.props.gradesMapSize; a++) {
						let isErrorElective = false
						let data1 = dataTableMap.get(i + "-" + a);
						if (data1 !== undefined) {
							if (this.props.activeErrorItem != {}) {

								data1.subjectCode = electiveData.elective.subjects[b].subjectCode
								isErrorElective = isErrorMethod('elective', this.props.activeErrorItem, data1, 3)
							}
							let bgColor = isErrorElective ? theme.palette.error.light : Constants.CC_RULES_ELECTIVE_BG;
							if (this.state.showRules === false || this.state.showRadioButtonValue === Constants.RULES_SHOW_RADIO_PERIOD || this.state.showRadioButtonValue === Constants.RULES_SHOW_RADIO_PERIOD_PREFS) {
								let cell = <TableCell bgcolor={bgColor} colspan={1} style={{ border: isErrorElective ? '2px solid ' + theme.palette.error.main : "none" }}></TableCell>
								cellArray.push(cell);
							} else {
								data1.border = isErrorElective ? '2px solid ' + theme.palette.error.main : "none";
								let cell = getTableCellShowModeForElective(data1, this.state.showRadioButtonValue, electiveData.elective.subjects[b].subjectCode);
								if (cell) {
									cellArray.push(cell);
								}

							}

						} else {
							cell = <TableCell bgcolor={Constants.CC_RULES_GREYCELLS_BG} colspan={1} />
							cellArray.push(cell);
						}

					}
					let row = <TableRow>{cellArray}</TableRow>
					rowArray.push(row);
				}

			}
		}
		return rowArray
	}

	onClickOfShowSectionsFilter = () => {
		this.props.handleShowSectionsFilter();
		this.setState({
			keys: []
		})

	}

	checkIfShowSectionsRequired(eventValue = this.state.showRadioButtonValue) {
		
		//check if show assigned rooms or teacher is clicked 
		if (Constants.RULES_SHOW_RADIO_ASSIGNED_ROOMS === eventValue || Constants.RULES_SHOW_RADIO_ASSIGNED_TEACHERS === eventValue) {
			//check if the show sections (groups) is clicked
			if (!this.props.filter.showSections) {
				this.showGroupsFilter.current.click();
			}
		}
	}
	handleShowRulesRadioChange = (event) => {
		const i18n = this.props.i18n
		let eventValue = parseInt(event.target.value);
		this.checkIfShowSectionsRequired(eventValue);
		this.setState({ showRadioButtonValue: eventValue });
		showToasterForRulesDisplay(eventValue, i18n);

	}

	undoChanges = () => {
		this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex] = JSON.parse(JSON.stringify(this.state.schedule_constraints_backup))
		this.setState({ totalPeriodsCreated: false, appliedChanges: false });
	}

	evalMessageString = (message) => {
		let text = "`" + message + "`";
		let msg = eval(text);
		return msg
	}

	handleDeleteMultiPeriodAndCreateNewTotalPeriod = () => {
		let cellData = this.state.cellData;
		let cellValue = this.state.cellValue;
		let multiPeriodsArray = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].multiPeriods
		if (cellData.groups != undefined) {
			let multiPeriodId = cellData.multiPeriod._id
			let multiPerioObjIndex = lodashUtil.findIndex(multiPeriodsArray, ["_id", multiPeriodId])
			if (multiPerioObjIndex != -1) {
				multiPeriodsArray.splice(multiPerioObjIndex, 1);
			}
		} else {
			let grade = cellData.grade
			for (let x = 0; x < multiPeriodsArray.length; x++) {
				let multiPeriodObj = multiPeriodsArray[x]
				if (multiPeriodObj.gradeDetails.grades[0].grade === grade) {
					multiPeriodsArray.splice(x, 1)
					x -= 1;
				}
			}
		}
		delete cellData.multiPeriod

		let totalPeriod = this.constructTotalPeriodsObject(cellData, cellValue)
		this.savingOfTotalPeriods(cellData, totalPeriod)
		this.setState({ totalPeriodsCreated: true, appliedChanges: false, alertDialogComponent: false });
		// this.totalPeriodsSaving(cellData, cellValue)

		// this.setState({ alertDialogComponent: false })
	}

	handleCloseDialog = () => {
		let cellData = this.state.cellData
		this.state.target.textContent = cellData.totalPeriod.count.toString()
		this.setState({ alertDialogComponent: false })
	}
	getIconSrc(errorLog) {
		if (this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].lastPreCheckedDate == undefined) {
			return theme.imageAlbum.readyForPrecheck
		}
		else if (errorLog.errorsCount > 0 && errorLog.warningsCount > 0) {
			return theme.imageAlbum.errorsAndWarningsIcon
		}
		else if (errorLog.errorsCount == 0 && errorLog.warningsCount == 0) {
			return theme.imageAlbum.noErrorOrWarningIcon
		}
		else if (errorLog.errorsCount == 0 && errorLog.warningsCount > 0) {
			return theme.imageAlbum.warningsOnlyIcon
		}
		else if (errorLog.errorsCount > 0 && errorLog.warningsCount == 0) {
			return theme.imageAlbum.errorOnlyIcon
		}
	}
	render() {
		const { classes, i18n } = this.props
		return (
			<MuiGrid container className={classes.filter_row} >
				<MuiGrid container xs>
					<MuiGrid className={classes.filter_row} container
						direction="row" alignItems='flex-start' justify='space-between'>
						<MuiGrid item xs align='left'>
							<PageHeaderComponent {...this.props} title={i18n.rules.title} />
						</MuiGrid>

						<MuiGrid item >
							{!this.props.disableEdit &&
								<MuiToolTip title={<MuiTypography style={{ fontSize: '14px', color: 'white', }}>{i18n.rules.applyChanges}</MuiTypography>} arrow classes={{ tooltip: classes.customWidth }} style={{ marginLeft: 4, padding: 4, textTransform: 'none' }}>

									<span>
										{/* <MuiButton
									style={!this.state.totalPeriodsCreated ? theme.primaryButtonDisabledStyle : theme.primaryButtonStyle}
									disabled={!this.state.totalPeriodsCreated}
									onClick={() => this.applyChangesMethod()}>
									Apply Changes
							</MuiButton> */}
										{!this.state.totalPeriodsCreated ? <img src={theme.imageAlbum.applyChangesInactive} style={theme.rulesIconsDimensionStyle} /> :
											<img src={theme.imageAlbum.applyChanges} style={{ width: '30px', cursor: 'pointer' }} onClick={() => this.applyChangesMethod()} />}
									</span>
								</MuiToolTip>}{!this.props.disableEdit &&
									<MuiToolTip title={<MuiTypography style={{ fontSize: '14px', color: 'white', }}>{i18n.rules.preCheckButtonToolTip}</MuiTypography>} arrow classes={{ tooltip: classes.customWidth }} style={{ marginLeft: 4, padding: 4, textTransform: 'none' }}>
										<span>
											{/* <MuiButton
										style={this.shouldEnablePreCheck() ? theme.primaryButtonDisabledStyle : theme.primaryButtonStyle}
										disabled={this.shouldEnablePreCheck()}
										onClick={() => this.props.verifyTimeTableMethod(this.props.displayError)}>
										Precheck
							</MuiButton> */}
											{this.shouldEnablePreCheck() ? <img src={theme.imageAlbum.precheckInactive} style={theme.rulesIconsDimensionStyle} /> :
												<img src={theme.imageAlbum.precheck} style={theme.rulesActiveIconsStyle} onClick={() => this.props.verifyTimeTableMethod(this.props.displayError)} />}
										</span>
									</MuiToolTip>}

							<MuiToolTip title={<MuiTypography style={{ fontSize: '14px', color: 'white', }}>{this.showToolTipForErrors()}</MuiTypography>} arrow classes={{ tooltip: classes.customWidth }} style={{ marginLeft: 4, padding: 4, textTransform: 'none' }}>

								<span>

									{/* <MuiButton
										style={!(this.props.errorLog.errors.length > 0) ? theme.primaryButtonDisabledStyle : theme.primaryButtonStyle}
										disabled={!(this.props.errorLog.errors.length > 0)}
										onClick={() => this.props.viewErrors(this.props.displayError)}>
										Errors and Warnings
								</MuiButton>  */}

									<img src={this.getIconSrc(this.props.errorLog)} style={theme.rulesActiveIconsStyle} onClick={() => this.props.viewErrors(this.props.displayError)} />

								</span>

							</MuiToolTip>

							{!this.props.disableEdit && <MuiToolTip title={<MuiTypography style={{ fontSize: '14px', color: 'white', }}>{this.props.activeSchool.license.usedTimetableCount >= this.props.activeSchool.license.timeTableQuantity ? i18n.rules.timeTableQuantityExceeded : i18n.rules.createTimeTableToolTip}</MuiTypography>} arrow style={{ marginLeft: 4, padding: 4, textTransform: 'none' }}
								classes={{ tooltip: classes.customWidth }}>
								<span>
									{/* <MuiButton
										style={!(this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].enableGenerateTimeTable) ? theme.primaryButtonDisabledStyle : theme.primaryButtonStyle}
										disabled={!this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].enableGenerateTimeTable}
										onClick={() => this.props.generateTimeTableMethod(this.props.displayError)}>
										Create Timetable
							</MuiButton>
							 */}
									{(this.props.activeSchool.license.usedTimetableCount >= this.props.activeSchool.license.timeTableQuantity) || !this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].enableGenerateTimeTable || this.state.totalPeriodsCreated == true ? <img src={theme.imageAlbum.createTimetableInactive} style={theme.rulesIconsDimensionStyle} /> :
										<img src={theme.imageAlbum.createTimetable} style={theme.rulesActiveIconsStyle} onClick={() => this.props.generateTimeTableMethod(this.props.displayError)} />}
								</span></MuiToolTip>}
						</MuiGrid>

					</MuiGrid>
					<MuiGrid xs>
						<MuiTypography align="left" variant={theme.typographyStyles.body} style={{ color: theme.palette.grey.darker, }} gutterBottom>

							{i18n.rules.subTitle}
						</MuiTypography></MuiGrid>

					<MuiGrid container fluid={true} direction="row" style={{ backgroundColor: 'white', marginTop: 3, marginBottom: 3, }}>

						<MuiGrid container xs lg={2} style={theme.gridTableStyleForRule}>
							<MuiGrid container xs={12} style={theme.pointer} alignContent="center" justify="space-around" alignItems="center" onClick={() => { this.props.toggleChangeForGradePicker() }}>


								{this.props.isGradeDropDownClicked === true ?

									<MuiGrid item xs={9} onClick={() => this.props.handleGradePickerClose()}>
										<MuiTypography style={theme.typography.h8}>{this.props.gradeString}</MuiTypography>
									</MuiGrid>
									:
									<MuiGrid item xs={9} onClick={() => this.props.handleGradePickerOpen()}>
										<MuiTypography style={theme.typography.h8}>{this.props.gradeString}</MuiTypography>
									</MuiGrid>
								}

								{this.props.isGradeDropDownClicked === true ?

									<MuiGrid item xs={3} align='left' onClick={() => this.props.handleGradePickerClose()}>
										<MuiKeyboardArrowUp style={{ color: theme.textColor }} />
									</MuiGrid>
									:
									<MuiGrid item xs={3} align='left' onClick={() => this.props.handleGradePickerOpen()}>
										<MuiKeyboardArrowDown style={{ color: theme.textColor }} />
									</MuiGrid>
								}

							</MuiGrid>
							{this.props.isGradeDropDownClicked === true &&
								<GradePickerComponent
									{...this.props}
									{...this.state}
									stopSelectionForGroups={this.props.openForFilterRules === true ? true : undefined}
									open={this.props.openForFilterRules}
									handleClose={this.props.handleGradePickerClose}
									handleOpen={this.props.handleGradePickerOpen}
									gradeLevels={this.props.gradeLevelForFilterRules}
									onClickOfSaveInGradePicker={this.props.onClickOfSaveInGradePicker}
								/>
							}
						</MuiGrid>
						<MuiGrid item container xs lg={2} style={theme.gridTableStyleForRule} alignContent="center" justify="space-around" alignItems="center">
							<MuiFormControlLabel
								onChange={() => this.onClickOfShowSectionsFilter()}
								style={{ marginLeft: '-11px' }}
								labelPlacement="start"
								ref={this.showGroupsFilter}
								control={
									<Switch
										//	color="primary"
										checked={this.props.filter !== undefined && this.props.filter.showSections}
										id='switch'
									// size="small" edge="end"
									/>
								}
								label={<MuiTypography style={theme.typography.h8} >{(i18n.rules.showSections).toUpperCase()}</MuiTypography>}

							/>
						</MuiGrid>
						<MuiGrid item container xs lg={2} alignContent="center" justify="space-around" alignItems="center" style={theme.gridTableStyleForRule}>
							<MuiFormControlLabel
								onChange={() => { this.props.handleShowAllSubjects() }}
								style={{ marginLeft: '-11px' }}
								labelPlacement="start"

								control={
									<Switch
										// color="primary"
										// edge="end"
										checked={this.props.filter !== undefined && this.props.filter.showAllSubjects}
										id='switch'
									//size="small"
									/>
								}
								label={<MuiTypography style={theme.typography.h8}>{(i18n.rules.showAllSubjects).toUpperCase()}</MuiTypography>}

							/>
						</MuiGrid>
						<MuiGrid item container className={classes.show_bar} xs={12} lg style={theme.gridTableShowRadio} justify="flex-start" alignItems="center">

							<MuiGrid item align='center' style={{ padding: " 0px 5px" }}>
								<MuiTypography style={theme.typography.h8}>{(i18n.rules.showTitle).toUpperCase()}</MuiTypography>
							</MuiGrid>
							<MuiGrid item align='center'>
								<CheckBox
									id="checkBox"
									color="primary"
									checked={this.state.showRules}
									onChange={(event) => this.onClickOfShowRulesCheckBox(event)}
									value={this.state.showRules} />
							</MuiGrid>

							<MuiGrid item xs={12} sm align='left'>
								<MuiFormControl size="small" component="fieldset">

									<MuiRadioGroup aria-label="position" name="position" value={this.state.showRadioButtonValue}
										onChange={(event) => this.handleShowRulesRadioChange(event)} row>



										<MuiFormControlLabel
											value={Constants.RULES_SHOW_RADIO_PERIOD}
											control={<Radio size="small" />}
											//	label={<MuiTypography style={theme.typography.span}>{i18n.rules.showPeriods}</MuiTypography>}
											label={<MuiToolTip title={<MuiTypography style={{ fontSize: '14px', color: 'white', }}>{i18n.rules.showPeriods}</MuiTypography>} arrow style={{ textTransform: 'none' }}>
												<img src={theme.imageAlbum.showPeriod} style={theme.rulesIconsDimensionStyle} />
											</MuiToolTip>}
											variant='caption'
											style={theme.showRulesRadion}
											labelPlacement="end"
											disabled={!this.state.showRules}
										/>
										<MuiFormControlLabel
											value={Constants.RULES_SHOW_RADIO_TEACHERS}
											control={<Radio size="small" />}
											//	label={<MuiTypography style={theme.typography.span}>{i18n.rules.showTeachers}</MuiTypography>}
											label={<MuiToolTip title={<MuiTypography style={{ fontSize: '14px', color: 'white', }}>{i18n.rules.showTeachers}</MuiTypography>} arrow style={{ textTransform: 'none' }}>
												<img src={theme.imageAlbum.showTeacher} style={theme.rulesIconsDimensionStyle} />
											</MuiToolTip>}
											style={theme.showRulesRadion}
											variant='caption'
											labelPlacement="end"
											disabled={!this.state.showRules}
										/>
										<MuiFormControlLabel
											value={Constants.RULES_SHOW_RADIO_PERIOD_PREFS}
											variant='caption'
											control={<Radio size="small" />}
											//label={<MuiTypography style={theme.typography.span}>{i18n.rules.showPeriodPreference}</MuiTypography>}
											label={<MuiToolTip title={<MuiTypography style={{ fontSize: '14px', color: 'white', }}>{i18n.rules.showPeriodPreference}</MuiTypography>} arrow style={{ textTransform: 'none' }}>
												<img src={theme.imageAlbum.showPeriodPreferences} style={theme.rulesIconsDimensionStyle} />
											</MuiToolTip>}
											style={theme.showRulesRadion}
											labelPlacement="end"
											disabled={!this.state.showRules}
										/>
										<MuiFormControlLabel
											value={Constants.RULES_SHOW_RADIO_ROOMS}
											variant='caption'
											control={<Radio size="small" />}
											//label={<MuiTypography style={theme.typography.span}>{i18n.rules.showRequireRooms}</MuiTypography>}
											label={<MuiToolTip title={<MuiTypography style={{ fontSize: '14px', color: 'white', }}>{i18n.rules.showRequireRooms}</MuiTypography>} arrow style={{ textTransform: 'none' }}>
												<img src={theme.imageAlbum.showRoom} style={theme.rulesIconsDimensionStyle} />
											</MuiToolTip>}
											style={theme.showRulesRadion}
											labelPlacement="end"
											disabled={!this.state.showRules}
										/>
										<MuiFormControlLabel
											value={Constants.RULES_SHOW_RADIO_ASSIGNED_TEACHERS}
											variant='caption'
											control={<Radio size="small" />}
											//label={<MuiTypography style={theme.typography.span}>{i18n.rules.showAssignedTeachers}</MuiTypography>}
											label={<MuiToolTip title={<MuiTypography style={{ fontSize: '14px', color: 'white', }}>{i18n.rules.showAssignedTeachers}</MuiTypography>} arrow style={{ textTransform: 'none' }}>
												<img src={theme.imageAlbum.showAssignedTeachers} style={theme.rulesIconsDimensionStyle} />
											</MuiToolTip>}
											style={theme.showRulesRadion}
											labelPlacement="end"
											disabled={!this.state.showRules}
										/>
										<MuiFormControlLabel
											value={Constants.RULES_SHOW_RADIO_ASSIGNED_ROOMS}
											variant='caption'
											control={<Radio size="small" />}
											//label={<MuiTypography style={theme.typography.span}>{i18n.rules.showAssignedRooms}</MuiTypography>}

											label={<MuiToolTip title={<MuiTypography style={{ fontSize: '14px', color: 'white', }}>{i18n.rules.showAssignedRooms}</MuiTypography>} arrow style={{ textTransform: 'none' }}>
												<img src={theme.imageAlbum.showAssignedRooms} style={theme.rulesIconsDimensionStyle} />
											</MuiToolTip>}
											style={theme.showRulesRadion}
											labelPlacement="end"
											disabled={!this.state.showRules}
										/>
									</MuiRadioGroup>
								</MuiFormControl>
							</MuiGrid>

						</MuiGrid>

						<br />
					</MuiGrid>

					{/* This is where the table starts */}
					<MuiGrid container style={{ border: '1px grey', paddingTop: '5px', flex: '1', flexDirection: 'row' }}>
						<MuiGrid item xs={12} style={{ width: 'auto', overflow: 'auto', flex: '1' }}>
							<Table
								id="rules_table"
								border={1}
								table-layout='fixed'
								borderColor={Constants.CC_RULES_GRID_BORDER}
								padding='checkbox'

								className={classes.table}
								width='100%'

							>
								<TableHead>

									<TableRow id="rules_grades_header">
										<TableCell className={classes.tableCell_1} bgcolor={Constants.CC_RULES_COLUMNHEADERS_BG} width="150px" colspan={1}><MuiTypography variant='caption' style={{ fontWeight: 600 }}>Grades</MuiTypography></TableCell>
										{this.getGradeTableCell()}
									</TableRow>

									<TableRow id="rules_sections_header">
										{this.props.filter !== undefined && this.props.filter.showSections && <TableCell colspan={1} bgcolor={Constants.CC_RULES_COLUMNHEADERS_BG}><MuiTypography variant='caption' style={{ fontWeight: 600 }}>Groups</MuiTypography></TableCell>}
										{this.props.filter !== undefined && this.props.filter.showSections && this.getGroupTableCell(classes)}
									</TableRow>
									<TableRow id="rules_total_periods_header">
										{this.props.filter !== undefined && !this.props.filter.showSections && <TableCell className={classes.tableCell_1} bgcolor={Constants.CC_RULES_TOTALPRD_HEAD_BG} width="150px" colspan={1} style={{ border: '1px solid ' + theme.palette.orange }}><MuiTypography variant='caption' style={{ color: 'white', fontWeight: 600 }}>Total Periods </MuiTypography> </TableCell>}
										{this.props.filter !== undefined && !this.props.filter.showSections && this.getTotalPeriodsTableCell(classes)}
									</TableRow>
									<TableRow id="rules_total_periods_header">
										{this.props.filter !== undefined && this.props.filter.showSections && <TableCell className={classes.tableCell_1} bgcolor={Constants.CC_RULES_TOTALPRD_HEAD_BG} width="150px" colspan={1} style={{ border: '1px solid ' + theme.palette.orange }}><MuiTypography variant='caption' style={{ color: 'white', fontWeight: 600 }}>Total Periods </MuiTypography> </TableCell>}
										{this.props.filter !== undefined && this.props.filter.showSections && this.getGroupTotalPeriodsTableCell(classes)}
									</TableRow>
								</TableHead>
								<TableBody
									display='block'
									overflow='scroll'
								>
									{this.getTableBody(this.props.subjects, this.props.masterGradeLevels, this.props.dataTableMap)}
								</TableBody>
							</Table>
						</MuiGrid>
					</MuiGrid></MuiGrid>
				{this.props.updateSchoolinformationInProgress && <img src={spinner} alt="none" style={theme.spinnerImgStyle} />}

				{this.state.alertDialogComponent &&
					<AlertDialogComponent
						{...this.props}
						errorMessage={i18n.totalPeriods.editingTotalPeriods}
						openDialog={this.state.alertDialogComponent}
						handleCloseDialog={this.handleCloseDialog}
						handleClickOnYes={this.handleDeleteMultiPeriodAndCreateNewTotalPeriod}
					/>
				}
			</MuiGrid>
		)
	}
}

export default withStyles(styles)(RulesComponent);